import { render } from "./B2bFilterButtonDeliveryNotesReceived.vue?vue&type=template&id=c6d0556e&scoped=true&lang=pug"
import script from "./B2bFilterButtonDeliveryNotesReceived.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonDeliveryNotesReceived.vue?vue&type=script&lang=js"

import "./B2bFilterButtonDeliveryNotesReceived.vue?vue&type=style&index=0&id=c6d0556e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6d0556e"]])

export default __exports__